import { createRoot } from "react-dom/client";
import { LabStatusCaseModal } from "../../lab_status_case_modal/LabStatusCaseModal";

export const initLabStatusCaseModal = () => {
  const labStatusCaseModalContainer = document.getElementById("lab-status-case-modal");
  const statusCaseButton = document.getElementById("lab-status-case-button");

  if (labStatusCaseModalContainer) {
    const root = createRoot(labStatusCaseModalContainer);
    const { caseId, denialReasonCodeOptions } = labStatusCaseModalContainer.dataset;

    root.render(
      <LabStatusCaseModal buttonEl={statusCaseButton} caseId={caseId} denialReasonCodeOptions={JSON.parse(denialReasonCodeOptions)} />
    );
  }
};
